import type { ReactNode } from 'react';

import type { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface StatusMessageProps {
  icon: IconDefinition;
  iconClassName: string;
  circleClassName?: string;
  heading?: ReactNode;
  headingClassName?: string;
  message: ReactNode;
  messageClassName?: string;
  className?: string;
}

const defaultContainerClassName =
  'vai-flex vai-flex-col vai-items-center vai-space-y-3 vai-py-8 vai-text-center';

export const StatusMessage = ({
  icon,
  iconClassName,
  circleClassName,
  heading,
  headingClassName = 'vai-text-lg vai-font-semibold',
  message,
  messageClassName = 'vai-text-sm vai-text-gray-500',
  className = defaultContainerClassName,
}: StatusMessageProps) => {
  return (
    <div className={className}>
      {circleClassName ? (
        <div
          className={`vai-flex vai-h-12 vai-w-12 vai-items-center vai-justify-center vai-rounded-full ${circleClassName}`}
        >
          <FontAwesomeIcon icon={icon} className={iconClassName} />
        </div>
      ) : (
        <FontAwesomeIcon icon={icon} className={iconClassName} />
      )}
      {heading && <h2 className={headingClassName}>{heading}</h2>}
      <p className={messageClassName}>{message}</p>
    </div>
  );
};
